<template>
  <div class="d-flex align-center">
    <svg
      v-if="name == 'toggle-icon'"
      :style="{ cursor: cursorPointer ? 'pointer' : '' }"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.26769 9.2275C1.25258 9.28963 1.2471 9.35371 1.25144 9.4175C1.23394 9.9175 1.41769 10.425 1.80019 10.8075L4.45019 13.46C4.5083 13.5181 4.57728 13.5642 4.65321 13.5957C4.72913 13.6271 4.81051 13.6433 4.89269 13.6433C4.97487 13.6433 5.05624 13.6271 5.13217 13.5957C5.20809 13.5642 5.27708 13.5181 5.33519 13.46C5.3933 13.4019 5.43939 13.3329 5.47084 13.257C5.50229 13.1811 5.51848 13.0997 5.51848 13.0175C5.51848 12.9353 5.50229 12.8539 5.47084 12.778C5.43939 12.7021 5.3933 12.6331 5.33519 12.575L2.76019 10H18.1252C18.2909 10 18.4499 9.93415 18.5671 9.81694C18.6843 9.69973 18.7502 9.54076 18.7502 9.375C18.7502 9.20924 18.6843 9.05027 18.5671 8.93306C18.4499 8.81585 18.2909 8.75 18.1252 8.75H2.97394L5.33519 6.3875C5.44432 6.26876 5.50333 6.11242 5.49988 5.95118C5.49643 5.78994 5.43077 5.63627 5.31665 5.52231C5.20253 5.40835 5.04877 5.34292 4.88753 5.33969C4.72628 5.33646 4.57003 5.39569 4.45144 5.505L1.80019 8.155C1.51024 8.44469 1.32319 8.82141 1.26769 9.2275ZM18.1252 3.75H9.37519C9.20943 3.75 9.05046 3.81585 8.93325 3.93306C8.81604 4.05027 8.75019 4.20924 8.75019 4.375C8.75019 4.54076 8.81604 4.69973 8.93325 4.81694C9.05046 4.93415 9.20943 5 9.37519 5H18.1252C18.2909 5 18.4499 4.93415 18.5671 4.81694C18.6843 4.69973 18.7502 4.54076 18.7502 4.375C18.7502 4.20924 18.6843 4.05027 18.5671 3.93306C18.4499 3.81585 18.2909 3.75 18.1252 3.75ZM18.1252 13.75H9.37519C9.20943 13.75 9.05046 13.8158 8.93325 13.9331C8.81604 14.0503 8.75019 14.2092 8.75019 14.375C8.75019 14.5408 8.81604 14.6997 8.93325 14.8169C9.05046 14.9342 9.20943 15 9.37519 15H18.1252C18.2909 15 18.4499 14.9342 18.5671 14.8169C18.6843 14.6997 18.7502 14.5408 18.7502 14.375C18.7502 14.2092 18.6843 14.0503 18.5671 13.9331C18.4499 13.8158 18.2909 13.75 18.1252 13.75Z"
        :fill="fill || 'black'"
      />
    </svg>
    <svg
      v-if="name == 'resize-icon'"
      :style="{ cursor: cursorPointer ? 'pointer' : '' }"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.1163 5H12.31V3.75H16.25V7.69H15V5.88375L11.6925 9.1925L10.8075 8.3075L14.1163 5ZM5 14.1163L8.3075 10.8075L9.1925 11.6925L5.88375 15H7.69V16.25H3.75V12.31H5V14.1163Z"
        :fill="fill || 'black'"
      />
    </svg>
    <svg
      v-if="name == 'setting-icon'"
      :style="{ cursor: cursorPointer ? 'pointer' : '' }"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7325 1.25C11.8648 1.25 11.9937 1.292 12.1007 1.36995C12.2076 1.4479 12.287 1.55778 12.3275 1.68375L13.015 3.82C13.3038 3.96125 13.58 4.12 13.8438 4.29875L16.0388 3.82625C16.1682 3.79862 16.303 3.81278 16.4239 3.86669C16.5447 3.92061 16.6454 4.01149 16.7113 4.12625L18.4438 7.125C18.5099 7.2397 18.5379 7.37244 18.5238 7.50409C18.5096 7.63574 18.454 7.75949 18.365 7.8575L16.8588 9.52C16.8807 9.83879 16.8807 10.1587 16.8588 10.4775L18.365 12.1425C18.454 12.2405 18.5096 12.3643 18.5238 12.4959C18.5379 12.6276 18.5099 12.7603 18.4438 12.875L16.7113 15.875C16.6452 15.9895 16.5445 16.0802 16.4236 16.1338C16.3028 16.1875 16.168 16.2015 16.0388 16.1737L13.8438 15.7013C13.5813 15.8787 13.3038 16.0388 13.0163 16.18L12.3275 18.3162C12.287 18.4422 12.2076 18.5521 12.1007 18.63C11.9937 18.708 11.8648 18.75 11.7325 18.75H8.26751C8.13519 18.75 8.00628 18.708 7.89936 18.63C7.79243 18.5521 7.713 18.4422 7.67251 18.3162L6.98626 16.1812C6.6983 16.0404 6.42054 15.8796 6.15501 15.7L3.96126 16.1737C3.83184 16.2014 3.697 16.1872 3.57614 16.1333C3.45528 16.0794 3.35466 15.9885 3.28876 15.8738L1.55626 12.875C1.49011 12.7603 1.46208 12.6276 1.47624 12.4959C1.49039 12.3643 1.54599 12.2405 1.63501 12.1425L3.14126 10.4775C3.11944 10.1595 3.11944 9.84046 3.14126 9.5225L1.63501 7.8575C1.54599 7.75949 1.49039 7.63574 1.47624 7.50409C1.46208 7.37244 1.49011 7.2397 1.55626 7.125L3.28876 4.125C3.35484 4.01047 3.45554 3.91984 3.57639 3.86616C3.69723 3.81248 3.83198 3.79851 3.96126 3.82625L6.15501 4.3C6.42001 4.12125 6.69751 3.96 6.98626 3.81875L7.67376 1.68375C7.71412 1.55818 7.79317 1.4486 7.8996 1.37069C8.00602 1.29278 8.13437 1.25053 8.26626 1.25H11.7313H11.7325ZM11.275 2.5H8.72501L8.01501 4.70875L7.53626 4.9425C7.30091 5.05767 7.07371 5.18881 6.85626 5.335L6.41376 5.635L4.14376 5.145L2.86876 7.355L4.42501 9.0775L4.38751 9.6075C4.36955 9.86886 4.36955 10.1311 4.38751 10.3925L4.42501 10.9225L2.86626 12.645L4.14251 14.855L6.41251 14.3663L6.85501 14.665C7.07246 14.8112 7.29966 14.9423 7.53501 15.0575L8.01376 15.2913L8.72501 17.5H11.2775L11.99 15.29L12.4675 15.0575C12.7026 14.9426 12.9294 14.8115 13.1463 14.665L13.5875 14.3663L15.8588 14.855L17.1338 12.645L15.5763 10.9225L15.6138 10.3925C15.6318 10.1307 15.6318 9.86802 15.6138 9.60625L15.5763 9.07625L17.135 7.355L15.8588 5.145L13.5875 5.6325L13.1463 5.335C12.9294 5.18854 12.7026 5.05739 12.4675 4.9425L11.99 4.71L11.2763 2.5H11.275ZM10 6.25C10.9946 6.25 11.9484 6.64509 12.6517 7.34835C13.3549 8.05161 13.75 9.00544 13.75 10C13.75 10.9946 13.3549 11.9484 12.6517 12.6517C11.9484 13.3549 10.9946 13.75 10 13.75C9.00545 13.75 8.05162 13.3549 7.34836 12.6517C6.6451 11.9484 6.25001 10.9946 6.25001 10C6.25001 9.00544 6.6451 8.05161 7.34836 7.34835C8.05162 6.64509 9.00545 6.25 10 6.25ZM10 7.5C9.33697 7.5 8.70109 7.76339 8.23225 8.23223C7.76341 8.70107 7.50001 9.33696 7.50001 10C7.50001 10.663 7.76341 11.2989 8.23225 11.7678C8.70109 12.2366 9.33697 12.5 10 12.5C10.6631 12.5 11.2989 12.2366 11.7678 11.7678C12.2366 11.2989 12.5 10.663 12.5 10C12.5 9.33696 12.2366 8.70107 11.7678 8.23223C11.2989 7.76339 10.6631 7.5 10 7.5Z"
        :fill="$vuetify.theme.isDark ? '#fff' : '#000'"
      />
    </svg>
    <svg
      v-if="name == 'update-icon'"
      :style="{ cursor: cursorPointer ? 'pointer' : '' }"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6107 10.8674C16.4534 12.0674 15.9723 13.2019 15.2192 14.1492C14.4661 15.0966 13.4693 15.821 12.3357 16.2449C11.2021 16.6688 9.97454 16.7761 8.7846 16.5554C7.59467 16.3346 6.48727 15.7941 5.58118 14.9918C4.67509 14.1895 4.00448 13.1557 3.64128 12.0013C3.27808 10.8468 3.23599 9.61527 3.51952 8.43872C3.80305 7.26216 4.4015 6.18498 5.2507 5.32269C6.0999 4.46041 7.16781 3.84555 8.33989 3.54406C11.5891 2.71073 14.9524 4.38323 16.1941 7.49989"
        :stroke="stroke || 'black'"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.6667 3.33301V7.49967H12.5"
        :stroke="stroke || 'black'"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'question-icon'"
      :style="{ cursor: cursorPointer ? 'pointer' : '' }"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 18.75C5.175 18.75 1.25 14.825 1.25 10C1.25 5.175 5.175 1.25 10 1.25C14.825 1.25 18.75 5.175 18.75 10C18.75 14.825 14.825 18.75 10 18.75ZM10 2.5C5.8625 2.5 2.5 5.8625 2.5 10C2.5 14.1375 5.8625 17.5 10 17.5C14.1375 17.5 17.5 14.1375 17.5 10C17.5 5.8625 14.1375 2.5 10 2.5Z"
        :fill="fill || 'black'"
      />
      <path
        d="M10 5.625C8.6125 5.625 7.5 6.7375 7.5 8.125H8.75C8.75 7.4375 9.3125 6.875 10 6.875C10.6875 6.875 11.25 7.4375 11.25 8.125C11.25 9.375 9.375 9.225 9.375 11.25H10.625C10.625 9.85 12.5 9.6875 12.5 8.125C12.5 6.7375 11.3875 5.625 10 5.625Z"
        :fill="fill || 'black'"
      />
      <path
        d="M10.0016 14.5246C10.4296 14.5246 10.7766 14.1776 10.7766 13.7496C10.7766 13.3216 10.4296 12.9746 10.0016 12.9746C9.57354 12.9746 9.22656 13.3216 9.22656 13.7496C9.22656 14.1776 9.57354 14.5246 10.0016 14.5246Z"
        :fill="fill || 'black'"
      />
      <path
        d="M8.125 8.75C8.47018 8.75 8.75 8.47018 8.75 8.125C8.75 7.77982 8.47018 7.5 8.125 7.5C7.77982 7.5 7.5 7.77982 7.5 8.125C7.5 8.47018 7.77982 8.75 8.125 8.75Z"
        :fill="fill || 'black'"
      />
      <path
        d="M10 11.875C10.3452 11.875 10.625 11.5952 10.625 11.25C10.625 10.9048 10.3452 10.625 10 10.625C9.65482 10.625 9.375 10.9048 9.375 11.25C9.375 11.5952 9.65482 11.875 10 11.875Z"
        :fill="fill || 'black'"
      />
    </svg>
    <svg
      v-if="name == 'alert-icon'"
      :style="{ cursor: cursorPointer ? 'pointer' : '' }"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9419 12.0581L16.25 10.3662V8.125C16.2481 6.57615 15.6719 5.08303 14.6329 3.93436C13.5939 2.7857 12.1659 2.06308 10.625 1.90625V0.625H9.375V1.90625C7.83411 2.06308 6.4061 2.7857 5.36711 3.93436C4.32811 5.08303 3.75194 6.57615 3.75 8.125V10.3662L2.05812 12.0581C1.94091 12.1753 1.87504 12.3343 1.875 12.5V14.375C1.875 14.5408 1.94085 14.6997 2.05806 14.8169C2.17527 14.9342 2.33424 15 2.5 15H6.875V15.4856C6.86113 16.2786 7.1405 17.0488 7.65954 17.6484C8.17858 18.2481 8.90073 18.635 9.6875 18.735C10.122 18.7781 10.5607 18.7298 10.9754 18.5931C11.3901 18.4565 11.7716 18.2346 12.0953 17.9416C12.4191 17.6487 12.678 17.2913 12.8553 16.8923C13.0326 16.4933 13.1245 16.0616 13.125 15.625V15H17.5C17.6658 15 17.8247 14.9342 17.9419 14.8169C18.0592 14.6997 18.125 14.5408 18.125 14.375V12.5C18.125 12.3343 18.0591 12.1753 17.9419 12.0581ZM11.875 15.625C11.875 16.1223 11.6775 16.5992 11.3258 16.9508C10.9742 17.3025 10.4973 17.5 10 17.5C9.50272 17.5 9.02581 17.3025 8.67417 16.9508C8.32254 16.5992 8.125 16.1223 8.125 15.625V15H11.875V15.625ZM16.875 13.75H3.125V12.7587L4.81687 11.0669C4.93409 10.9497 4.99996 10.7907 5 10.625V8.125C5 6.79892 5.52678 5.52715 6.46447 4.58947C7.40215 3.65178 8.67392 3.125 10 3.125C11.3261 3.125 12.5979 3.65178 13.5355 4.58947C14.4732 5.52715 15 6.79892 15 8.125V10.625C15 10.7907 15.0659 10.9497 15.1831 11.0669L16.875 12.7587V13.75Z"
        :fill="$vuetify.theme.isDark ? '#fff' : '#030303'"
      />
    </svg>
    <svg
      v-if="name == 'support-icon'"
      :style="{ cursor: cursorPointer ? 'pointer' : '' }"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 14.5C9.49719 14.5001 9.01279 14.3108 8.64327 13.9698C8.27375 13.6289 8.04622 13.1612 8.006 12.66C6.67219 12.1879 5.54805 11.2597 4.83202 10.0394C4.116 8.81901 3.85412 7.38493 4.09263 5.99027C4.33113 4.59561 5.05467 3.33005 6.13554 2.41698C7.21641 1.50392 8.5851 1.00206 10 1C11.5049 0.999782 12.9549 1.56509 14.0626 2.58383C15.1702 3.60256 15.8546 5.00034 15.98 6.5C15.9842 6.56505 15.9748 6.63026 15.9524 6.69148C15.93 6.7527 15.8952 6.8086 15.85 6.85562C15.8049 6.90264 15.7504 6.93976 15.6902 6.96461C15.6299 6.98947 15.5652 7.00152 15.5 7C15.3661 6.99664 15.2381 6.94361 15.1411 6.8512C15.0441 6.7588 14.9849 6.63362 14.975 6.5C14.8859 5.61584 14.5628 4.77138 14.039 4.05357C13.5151 3.33576 12.8094 2.77054 11.9945 2.41609C11.1796 2.06163 10.285 1.93076 9.40274 2.03694C8.52046 2.14313 7.68243 2.48252 6.97491 3.0202C6.26739 3.55787 5.71594 4.2744 5.37735 5.096C5.03876 5.9176 4.92525 6.8146 5.04851 7.69465C5.17177 8.5747 5.52734 9.406 6.07863 10.103C6.62991 10.7999 7.35699 11.3374 8.185 11.66C8.33566 11.3345 8.57111 11.0554 8.86667 10.8521C9.16224 10.6489 9.50703 10.5288 9.86493 10.5046C10.2228 10.4803 10.5807 10.5528 10.9009 10.7144C11.2212 10.876 11.4921 11.1207 11.6853 11.423C11.8785 11.7253 11.9868 12.0739 11.9989 12.4324C12.011 12.7909 11.9265 13.1461 11.7542 13.4607C11.5819 13.7754 11.3281 14.0379 11.0195 14.2207C10.7108 14.4035 10.3587 14.5 10 14.5ZM5.009 12H5.1C5.49 12.381 5.923 12.717 6.392 13H5.009C4.448 13 4 13.447 4 14C4 15.309 4.622 16.284 5.673 16.953C6.743 17.636 8.265 18 10 18C11.735 18 13.257 17.636 14.327 16.953C15.377 16.283 16 15.31 16 14C16 13.7348 15.8946 13.4804 15.7071 13.2929C15.5196 13.1054 15.2652 13 15 13H12.959C13.0149 12.669 13.0149 12.331 12.959 12H15C15.5304 12 16.0391 12.2107 16.4142 12.5858C16.7893 12.9609 17 13.4696 17 14C17 15.691 16.167 16.966 14.865 17.797C13.583 18.614 11.855 19 10 19C8.145 19 6.417 18.614 5.135 17.797C3.833 16.967 3 15.69 3 14C3 12.887 3.903 12 5.009 12ZM14 7C14.0002 7.67664 13.8288 8.34227 13.5017 8.93463C13.1747 9.52698 12.7027 10.0267 12.13 10.387C11.863 10.1178 11.5475 9.90166 11.2 9.75C11.8317 9.47431 12.3492 8.98953 12.6655 8.37716C12.9817 7.7648 13.0775 7.06221 12.9367 6.38753C12.7959 5.71284 12.4271 5.10722 11.8922 4.6725C11.3574 4.23777 10.6892 4.00045 10 4.00045C9.31078 4.00045 8.64258 4.23777 8.10775 4.6725C7.57293 5.10722 7.2041 5.71284 7.06328 6.38753C6.92247 7.06221 7.01826 7.7648 7.33454 8.37716C7.65083 8.98953 8.16832 9.47431 8.8 9.75C8.45 9.903 8.135 10.12 7.87 10.387C7.11042 9.90932 6.53351 9.19012 6.232 8.345C6.07818 7.91327 5.99971 7.45831 6 7C6 5.93913 6.42143 4.92172 7.17157 4.17157C7.92172 3.42143 8.93913 3 10 3C11.0609 3 12.0783 3.42143 12.8284 4.17157C13.5786 4.92172 14 5.93913 14 7Z"
        :fill="fill || 'black'"
      />
    </svg>
    <svg
      v-if="name == 'cash-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.32812 13V5.5C2.32812 5.10218 2.48616 4.72064 2.76746 4.43934C3.04877 4.15804 3.4303 4 3.82812 4H15.8281C16.2259 4 16.6075 4.15804 16.8888 4.43934C17.1701 4.72064 17.3281 5.10218 17.3281 5.5V13C17.3281 13.3978 17.1701 13.7794 16.8888 14.0607C16.6075 14.342 16.2259 14.5 15.8281 14.5H3.82812C3.4303 14.5 3.04877 14.342 2.76746 14.0607C2.48616 13.7794 2.32813 13.3978 2.32812 13Z"
        stroke="#fff"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.7031 9.2575L14.7106 9.24925M4.95312 9.2575L4.96063 9.24925M9.82812 11.5C9.23139 11.5 8.65909 11.2629 8.23713 10.841C7.81518 10.419 7.57812 9.84674 7.57812 9.25C7.57812 8.65326 7.81518 8.08097 8.23713 7.65901C8.65909 7.23705 9.23139 7 9.82812 7C10.4249 7 10.9972 7.23705 11.4191 7.65901C11.8411 8.08097 12.0781 8.65326 12.0781 9.25C12.0781 9.84674 11.8411 10.419 11.4191 10.841C10.9972 11.2629 10.4249 11.5 9.82812 11.5Z"
        stroke="#fff"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'card-pos-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 19 19"
      :fill="compositeType == 'pay' ? 'silver' : '#0066ff'"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.0095 12.3985L12.6313 2.776M14.474 8.542L12.824 10.192M11.4163 11.5825L10.682 12.3168M3.5 16.75H15.5M2.88125 12.3558C2.60187 12.0765 2.38024 11.7449 2.22903 11.3799C2.07783 11.015 2 10.6238 2 10.2288C2 9.83371 2.07783 9.44254 2.22903 9.07759C2.38024 8.71263 2.60187 8.38104 2.88125 8.10175L8.35175 2.63125C8.63104 2.35187 8.96263 2.13024 9.32759 1.97903C9.69254 1.82783 10.0837 1.75 10.4788 1.75C10.8738 1.75 11.265 1.82783 11.6299 1.97903C11.9949 2.13024 12.3265 2.35187 12.6058 2.63125L16.1188 6.14425C16.3981 6.42354 16.6198 6.75513 16.771 7.12009C16.9222 7.48504 17 7.87621 17 8.27125C17 8.66629 16.9222 9.05746 16.771 9.42242C16.6198 9.78738 16.3981 10.119 16.1188 10.3983L10.6483 15.8688C10.369 16.1481 10.0374 16.3698 9.67242 16.521C9.30746 16.6722 8.91629 16.75 8.52125 16.75C8.12621 16.75 7.73504 16.6722 7.37009 16.521C7.00513 16.3698 6.67354 16.1481 6.39425 15.8688L2.88125 12.3558Z"
        stroke="silver"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'bottom-left-cursor-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0744 5.25C14.8755 5.25 14.6847 5.32902 14.5441 5.46967C14.4034 5.61032 14.3244 5.80109 14.3244 6V9C14.3244 9.19891 14.2454 9.38968 14.1047 9.53033C13.9641 9.67098 13.7733 9.75 13.5744 9.75H6.38188L7.35689 8.7825C7.49811 8.64127 7.57745 8.44973 7.57745 8.25C7.57745 8.05027 7.49811 7.85873 7.35689 7.7175C7.21566 7.57627 7.02411 7.49693 6.82439 7.49693C6.62466 7.49693 6.43311 7.57627 6.29189 7.7175L4.04189 9.9675C3.9736 10.0388 3.92008 10.1229 3.88439 10.215C3.80937 10.3976 3.80937 10.6024 3.88439 10.785C3.92008 10.8771 3.9736 10.9612 4.04189 11.0325L6.29189 13.2825C6.36161 13.3528 6.44456 13.4086 6.53595 13.4467C6.62735 13.4847 6.72538 13.5043 6.82439 13.5043C6.92339 13.5043 7.02142 13.4847 7.11282 13.4467C7.20421 13.4086 7.28716 13.3528 7.35689 13.2825C7.42718 13.2128 7.48298 13.1298 7.52105 13.0384C7.55913 12.947 7.57873 12.849 7.57873 12.75C7.57873 12.651 7.55913 12.553 7.52105 12.4616C7.48298 12.3702 7.42718 12.2872 7.35689 12.2175L6.38188 11.25H13.5744C14.1711 11.25 14.7434 11.0129 15.1654 10.591C15.5873 10.169 15.8244 9.59674 15.8244 9V6C15.8244 5.80109 15.7454 5.61032 15.6047 5.46967C15.4641 5.32902 15.2733 5.25 15.0744 5.25Z"
        fill="#FCFCFC"
      />
    </svg>
    <svg
      v-if="name == 'print-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 13.6875H14.8438C15.2164 13.6864 15.5734 13.5379 15.8369 13.2744C16.1004 13.0109 16.2489 12.6539 16.25 12.2812V6.65625C16.2489 6.28363 16.1004 5.92659 15.8369 5.66311C15.5734 5.39963 15.2164 5.25111 14.8438 5.25H4.15625C3.78363 5.25111 3.42659 5.39963 3.16311 5.66311C2.89963 5.92659 2.75111 6.28363 2.75 6.65625V12.2812C2.75111 12.6539 2.89963 13.0109 3.16311 13.2744C3.42659 13.5379 3.78363 13.6864 4.15625 13.6875H5"
        stroke="#999999"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
      <path
        d="M13.145 9.1875H5.855C5.3828 9.1875 5 9.5703 5 10.0425V15.645C5 16.1172 5.3828 16.5 5.855 16.5H13.145C13.6172 16.5 14 16.1172 14 15.645V10.0425C14 9.5703 13.6172 9.1875 13.145 9.1875Z"
        stroke="#999999"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
      <path
        d="M14 5.25V4.40625C13.9989 4.03363 13.8504 3.67659 13.5869 3.41311C13.3234 3.14963 12.9664 3.00111 12.5938 3H6.40625C6.03363 3.00111 5.67659 3.14963 5.41311 3.41311C5.14963 3.67659 5.00111 4.03363 5 4.40625V5.25"
        stroke="#999999"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
      <path
        d="M14.2812 8.0625C14.7472 8.0625 15.125 7.68474 15.125 7.21875C15.125 6.75276 14.7472 6.375 14.2812 6.375C13.8153 6.375 13.4375 6.75276 13.4375 7.21875C13.4375 7.68474 13.8153 8.0625 14.2812 8.0625Z"
        fill="#999999"
      />
    </svg>
    <svg
      v-if="name == 'trash-icon'"
      :style="{ cursor: cursorPointer ? 'pointer' : '' }"
      :width="width"
      :height="height"
      viewBox="0 0 16 17"
      :fill="fill"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.625 3.375H5.5C5.56875 3.375 5.625 3.31875 5.625 3.25V3.375ZM5.625 3.375H10.375V3.25C10.375 3.31875 10.4312 3.375 10.5 3.375H10.375V4.5H11.5V3.25C11.5 2.69844 11.0516 2.25 10.5 2.25H5.5C4.94844 2.25 4.5 2.69844 4.5 3.25V4.5H5.625V3.375ZM13.5 4.5H2.5C2.22344 4.5 2 4.72344 2 5V5.5C2 5.56875 2.05625 5.625 2.125 5.625H3.06875L3.45469 13.7969C3.47969 14.3297 3.92031 14.75 4.45312 14.75H11.5469C12.0813 14.75 12.5203 14.3313 12.5453 13.7969L12.9312 5.625H13.875C13.9438 5.625 14 5.56875 14 5.5V5C14 4.72344 13.7766 4.5 13.5 4.5ZM11.4266 13.625H4.57344L4.19531 5.625H11.8047L11.4266 13.625Z"
        :fill="fill"
      ></path>
    </svg>
    <svg
      v-if="name == 'edit-icon'"
      :style="{ cursor: cursorPointer ? 'pointer' : '' }"
      :width="width"
      :height="height"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        :stroke="stroke"
        d="M2.66797 14.5002H13.3346M3.77864 9.29156C3.49438 9.57645 3.33471 9.96244 3.33464 10.3649V12.5002H5.4833C5.88597 12.5002 6.27197 12.3402 6.55664 12.0549L12.89 5.71822C13.1741 5.43329 13.3337 5.0473 13.3337 4.64489C13.3337 4.24248 13.1741 3.85649 12.89 3.57156L12.2646 2.94489C12.1236 2.80379 11.9562 2.69187 11.7718 2.61554C11.5875 2.5392 11.39 2.49994 11.1905 2.5C10.991 2.50006 10.7935 2.53944 10.6092 2.6159C10.425 2.69235 10.2576 2.80437 10.1166 2.94556L3.77864 9.29156Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </svg>
    <svg
      v-if="name == 'composite-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66406 14.875H16.6641V2.875H4.66406V5.875"
        stroke="#030303"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
      <path
        d="M3.16406 14.875H12.1641V5.875H3.16406V8.875"
        stroke="#030303"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
      <path
        d="M7.66406 8.875H1.66406V14.875H7.66406V8.875Z"
        stroke="#030303"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'plus-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66797 14.5002H13.3346M3.77864 9.29156C3.49438 9.57645 3.33471 9.96244 3.33464 10.3649V12.5002H5.4833C5.88597 12.5002 6.27197 12.3402 6.55664 12.0549L12.89 5.71822C13.1741 5.43329 13.3337 5.0473 13.3337 4.64489C13.3337 4.24248 13.1741 3.85649 12.89 3.57156L12.2646 2.94489C12.1236 2.80379 11.9562 2.69187 11.7718 2.61554C11.5875 2.5392 11.39 2.49994 11.1905 2.5C10.991 2.50006 10.7935 2.53944 10.6092 2.6159C10.425 2.69235 10.2576 2.80437 10.1166 2.94556L3.77864 9.29156Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </svg>
    <svg
      v-if="name == 'document-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.879 2.879C5 3.757 5 5.172 5 8V16C5 18.828 5 20.243 5.879 21.121C6.757 22 8.172 22 11 22H13C15.828 22 17.243 22 18.121 21.121C19 20.243 19 18.828 19 16V8C19 5.172 19 3.757 18.121 2.879C17.243 2 15.828 2 13 2H11C8.172 2 6.757 2 5.879 2.879ZM8.25 17C8.25 16.8011 8.32902 16.6103 8.46967 16.4697C8.61032 16.329 8.80109 16.25 9 16.25H12C12.1989 16.25 12.3897 16.329 12.5303 16.4697C12.671 16.6103 12.75 16.8011 12.75 17C12.75 17.1989 12.671 17.3897 12.5303 17.5303C12.3897 17.671 12.1989 17.75 12 17.75H9C8.80109 17.75 8.61032 17.671 8.46967 17.5303C8.32902 17.3897 8.25 17.1989 8.25 17ZM9 12.25C8.80109 12.25 8.61032 12.329 8.46967 12.4697C8.32902 12.6103 8.25 12.8011 8.25 13C8.25 13.1989 8.32902 13.3897 8.46967 13.5303C8.61032 13.671 8.80109 13.75 9 13.75H15C15.1989 13.75 15.3897 13.671 15.5303 13.5303C15.671 13.3897 15.75 13.1989 15.75 13C15.75 12.8011 15.671 12.6103 15.5303 12.4697C15.3897 12.329 15.1989 12.25 15 12.25H9ZM8.25 9C8.25 8.80109 8.32902 8.61032 8.46967 8.46967C8.61032 8.32902 8.80109 8.25 9 8.25H15C15.1989 8.25 15.3897 8.32902 15.5303 8.46967C15.671 8.61032 15.75 8.80109 15.75 9C15.75 9.19891 15.671 9.38968 15.5303 9.53033C15.3897 9.67098 15.1989 9.75 15 9.75H9C8.80109 9.75 8.61032 9.67098 8.46967 9.53033C8.32902 9.38968 8.25 9.19891 8.25 9Z"
        :fill="fill || '#484848'"
      />
      <path
        opacity="0.5"
        d="M5.235 4.05469C5 4.93769 5 6.17369 5 7.99669V15.9967C5 17.8197 5 19.0547 5.235 19.9387L5 19.9207C4.025 19.8247 3.369 19.6077 2.879 19.1177C2 18.2397 2 16.8247 2 13.9967V9.99669C2 7.16769 2 5.75369 2.879 4.87569C3.369 4.38569 4.025 4.16869 5 4.07269L5.235 4.05469ZM18.765 19.9387C19 19.0547 19 17.8187 19 15.9967V7.99669C19 6.17369 19 4.93769 18.765 4.05469L19 4.07269C19.975 4.16869 20.631 4.38569 21.121 4.87569C22 5.75369 22 7.16669 22 9.99569V13.9957C22 16.8257 22 18.2387 21.121 19.1177C20.631 19.6077 19.975 19.8247 19 19.9207L18.765 19.9387Z"
        :fill="fill || '#484848'"
      />
    </svg>
    <svg
      v-if="name == 'download-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 8L3.5 5.5L4.2 4.775L5.5 6.075V2H6.5V6.075L7.8 4.775L8.5 5.5L6 8ZM3 10C2.725 10 2.48967 9.90217 2.294 9.7065C2.09833 9.51083 2.00033 9.27533 2 9V7.5H3V9H9V7.5H10V9C10 9.275 9.90217 9.5105 9.7065 9.7065C9.51083 9.9025 9.27533 10.0003 9 10H3Z"
        fill="#030303"
      />
    </svg>
    <svg
      v-if="name == 'trol-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.28832 3.74759C1.35109 3.55893 1.48622 3.40291 1.66398 3.31384C1.84175 3.22477 2.04761 3.20993 2.23632 3.27259L2.50132 3.36159L2.54132 3.37459C3.16732 3.58359 3.69632 3.75959 4.11332 3.95359C4.55532 4.15959 4.93932 4.41359 5.23032 4.81859C5.52132 5.22159 5.64232 5.66659 5.69732 6.15159C5.74932 6.60759 5.74932 7.16559 5.74932 7.82559V10.4846C5.74932 11.9196 5.75132 12.9216 5.85232 13.6766C5.95132 14.4106 6.13232 14.7986 6.40832 15.0756C6.68532 15.3526 7.07432 15.5326 7.80832 15.6316C8.56332 15.7326 9.56432 15.7346 10.9993 15.7346H17.9993C18.0978 15.7346 18.1953 15.754 18.2863 15.7917C18.3773 15.8294 18.46 15.8846 18.5296 15.9543C18.5993 16.0239 18.6545 16.1066 18.6922 16.1976C18.7299 16.2886 18.7493 16.3861 18.7493 16.4846C18.7493 16.5831 18.7299 16.6806 18.6922 16.7716C18.6545 16.8626 18.5993 16.9453 18.5296 17.0149C18.46 17.0846 18.3773 17.1398 18.2863 17.1775C18.1953 17.2152 18.0978 17.2346 17.9993 17.2346H10.9443C9.57732 17.2346 8.47432 17.2346 7.60732 17.1176C6.70732 16.9976 5.94932 16.7376 5.34732 16.1366C4.74632 15.5346 4.48732 14.7766 4.36632 13.8766C4.24932 13.0096 4.24932 11.9066 4.24932 10.5396V7.86759C4.24932 7.15459 4.24932 6.68259 4.20732 6.32159C4.16732 5.97959 4.10032 5.81459 4.01332 5.69559C3.92732 5.57559 3.79232 5.45859 3.48032 5.31359C3.15032 5.16059 2.70332 5.00959 2.02732 4.78359L1.76232 4.69559C1.57384 4.63261 1.41805 4.49741 1.32918 4.31966C1.24031 4.14192 1.22561 3.93617 1.28832 3.74759Z"
        fill="#FCFCFC"
      />
      <path
        opacity="0.5"
        d="M5.74609 6.98438C5.75009 7.24437 5.75176 7.52471 5.75109 7.82538V10.4844C5.75109 11.9194 5.75309 12.9214 5.85409 13.6764C5.86943 13.7864 5.88609 13.889 5.90409 13.9844H16.0241C16.9831 13.9844 17.4621 13.9844 17.8381 13.7364C18.2141 13.4884 18.4031 13.0484 18.7801 12.1664L19.2101 11.1664C20.0191 9.27638 20.4231 8.33337 19.9791 7.65837C19.5351 6.98337 18.5071 6.98438 16.4511 6.98438H5.74609Z"
        fill="#FCFCFC"
      />
      <path
        d="M7.5 18.9844C7.89782 18.9844 8.27936 19.1424 8.56066 19.4237C8.84196 19.705 9 20.0866 9 20.4844C9 20.8822 8.84196 21.2637 8.56066 21.545C8.27936 21.8263 7.89782 21.9844 7.5 21.9844C7.10218 21.9844 6.72064 21.8263 6.43934 21.545C6.15804 21.2637 6 20.8822 6 20.4844C6 20.0866 6.15804 19.705 6.43934 19.4237C6.72064 19.1424 7.10218 18.9844 7.5 18.9844ZM18 20.4844C18 20.0866 17.842 19.705 17.5607 19.4237C17.2794 19.1424 16.8978 18.9844 16.5 18.9844C16.1022 18.9844 15.7206 19.1424 15.4393 19.4237C15.158 19.705 15 20.0866 15 20.4844C15 20.8822 15.158 21.2637 15.4393 21.545C15.7206 21.8263 16.1022 21.9844 16.5 21.9844C16.8978 21.9844 17.2794 21.8263 17.5607 21.545C17.842 21.2637 18 20.8822 18 20.4844Z"
        fill="#FCFCFC"
      />
    </svg>
    <svg
      v-if="name == 'championship-cup-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M12.0019 16.9846C6.24193 16.9846 5.22193 11.2446 5.04193 6.6906C4.99093 5.4246 4.96593 4.7906 5.44193 4.2056C5.91693 3.6196 6.48593 3.5236 7.62493 3.3316C9.07176 3.0946 10.5358 2.97853 12.0019 2.9846C13.7859 2.9846 15.2549 3.1416 16.3789 3.3316C17.5179 3.5236 18.0869 3.6196 18.5629 4.2056C19.0389 4.7916 19.0129 5.4246 18.9629 6.6906C18.7829 11.2446 17.7629 16.9846 12.0029 16.9846"
        fill="#FCFCFC"
      />
      <path
        d="M17.64 13.4064L20.457 11.8414C21.209 11.4234 21.585 11.2144 21.793 10.8624C22 10.5104 22 10.0804 22 9.21937V9.14637C22 8.10337 22 7.58138 21.717 7.18837C21.434 6.79537 20.939 6.63038 19.949 6.30037L19 5.98438L18.983 6.06938C18.9777 6.25804 18.9703 6.46504 18.961 6.69037C18.873 8.91537 18.584 11.4234 17.641 13.4064M5.04 6.69037C5.127 8.91537 5.416 11.4234 6.36 13.4064L3.543 11.8414C2.791 11.4234 2.414 11.2144 2.207 10.8624C2 10.5104 2 10.0804 2 9.21937V9.14637C2 8.10337 2 7.58138 2.283 7.18837C2.566 6.79537 3.061 6.63038 4.051 6.30037L5 5.98438L5.017 6.07137C5.02233 6.25871 5.02967 6.46537 5.039 6.69137"
        fill="#FCFCFC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.25 22.9844C5.25 22.7855 5.32902 22.5947 5.46967 22.454C5.61032 22.3134 5.80109 22.2344 6 22.2344H18C18.1989 22.2344 18.3897 22.3134 18.5303 22.454C18.671 22.5947 18.75 22.7855 18.75 22.9844C18.75 23.1833 18.671 23.3741 18.5303 23.5147C18.3897 23.6554 18.1989 23.7344 18 23.7344H6C5.80109 23.7344 5.61032 23.6554 5.46967 23.5147C5.32902 23.3741 5.25 23.1833 5.25 22.9844Z"
        fill="#FCFCFC"
      />
      <path
        opacity="0.5"
        d="M15.459 22.2337H8.54297L8.83997 20.4837C8.88526 20.2571 9.00764 20.0531 9.18631 19.9066C9.36497 19.76 9.58888 19.6798 9.81997 19.6797H14.181C14.4121 19.6798 14.636 19.76 14.8146 19.9066C14.9933 20.0531 15.1157 20.2571 15.161 20.4837L15.459 22.2337Z"
        fill="#FCFCFC"
      />
      <path
        d="M12 16.9871C11.74 16.9871 11.49 16.9758 11.25 16.9531V19.6831H12.75V16.9531C12.5007 16.9762 12.2504 16.9875 12 16.9871Z"
        fill="#FCFCFC"
      />
    </svg>
    <svg
      v-if="name == 'fire-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M13.332 21.8012C16.458 21.1752 20.5 18.9262 20.5 13.1112C20.5 7.82017 16.627 4.29617 13.842 2.67717C13.223 2.31717 12.5 2.79018 12.5 3.50517V5.33318C12.5 6.77518 11.894 9.40718 10.21 10.5022C9.35 11.0612 8.42 10.2242 8.316 9.20418L8.23 8.36618C8.13 7.39218 7.138 6.80118 6.36 7.39517C4.961 8.46018 3.5 10.3302 3.5 13.1102C3.5 20.2212 8.789 22.0002 11.433 22.0002C11.5877 22.0002 11.749 21.9952 11.917 21.9852C12.363 21.9292 11.917 22.0842 13.332 21.8002"
        fill="#00664D"
      />
      <path
        d="M8.5 18.4444C8.5 21.0644 10.611 21.8744 11.917 21.9864C12.363 21.9304 11.917 22.0854 13.332 21.8014C14.371 21.4344 15.5 20.4924 15.5 18.4444C15.5 17.1474 14.681 16.3464 14.04 15.9714C13.844 15.8564 13.616 16.0014 13.599 16.2274C13.543 16.9454 12.853 17.5174 12.384 16.9714C11.969 16.4894 11.794 15.7844 11.794 15.3334V14.7434C11.794 14.3894 11.437 14.1534 11.131 14.3354C9.995 15.0084 8.5 16.3944 8.5 18.4444Z"
        fill="#00664D"
      />
    </svg>
    <svg
      v-if="name == 'persons-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 7.5C15.5 7.95963 15.4095 8.41475 15.2336 8.83939C15.0577 9.26403 14.7999 9.64987 14.4749 9.97487C14.1499 10.2999 13.764 10.5577 13.3394 10.7336C12.9148 10.9095 12.4596 11 12 11C11.5404 11 11.0852 10.9095 10.6606 10.7336C10.236 10.5577 9.85013 10.2999 9.52513 9.97487C9.20012 9.64987 8.94231 9.26403 8.76642 8.83939C8.59053 8.41475 8.5 7.95963 8.5 7.5C8.5 6.57174 8.86875 5.6815 9.52513 5.02513C10.1815 4.36875 11.0717 4 12 4C12.9283 4 13.8185 4.36875 14.4749 5.02513C15.1313 5.6815 15.5 6.57174 15.5 7.5Z"
        fill="#0066FF"
      />
      <path
        opacity="0.4"
        d="M19.5 7.5C19.5 8.16304 19.2366 8.79893 18.7678 9.26777C18.2989 9.73661 17.663 10 17 10C16.337 10 15.7011 9.73661 15.2322 9.26777C14.7634 8.79893 14.5 8.16304 14.5 7.5C14.5 6.83696 14.7634 6.20107 15.2322 5.73223C15.7011 5.26339 16.337 5 17 5C17.663 5 18.2989 5.26339 18.7678 5.73223C19.2366 6.20107 19.5 6.83696 19.5 7.5ZM4.5 7.5C4.5 8.16304 4.76339 8.79893 5.23223 9.26777C5.70107 9.73661 6.33696 10 7 10C7.66304 10 8.29893 9.73661 8.76777 9.26777C9.23661 8.79893 9.5 8.16304 9.5 7.5C9.5 6.83696 9.23661 6.20107 8.76777 5.73223C8.29893 5.26339 7.66304 5 7 5C6.33696 5 5.70107 5.26339 5.23223 5.73223C4.76339 6.20107 4.5 6.83696 4.5 7.5Z"
        fill="#0066FF"
      />
      <path
        d="M18 16.5C18 18.433 15.314 20 12 20C8.686 20 6 18.433 6 16.5C6 14.567 8.686 13 12 13C15.314 13 18 14.567 18 16.5Z"
        fill="#0066FF"
      />
      <path
        opacity="0.4"
        d="M22 16.5C22 17.88 20.21 19 18 19C15.79 19 14 17.88 14 16.5C14 15.12 15.79 14 18 14C20.21 14 22 15.12 22 16.5ZM2 16.5C2 17.88 3.79 19 6 19C8.21 19 10 17.88 10 16.5C10 15.12 8.21 14 6 14C3.79 14 2 15.12 2 16.5Z"
        fill="#0066FF"
      />
    </svg>
    <svg
      v-if="name == 'trol2-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.78892 3.26322C1.85169 3.07455 1.98682 2.91854 2.16458 2.82946C2.34235 2.74039 2.54821 2.72556 2.73692 2.78822L3.00192 2.87722L3.04192 2.89022C3.66792 3.09922 4.19692 3.27522 4.61392 3.46922C5.05592 3.67522 5.43992 3.92922 5.73092 4.33422C6.02192 4.73722 6.14292 5.18222 6.19792 5.66722C6.24992 6.12322 6.24992 6.68122 6.24992 7.34122V10.0002C6.24992 11.4352 6.25192 12.4372 6.35292 13.1922C6.45192 13.9262 6.63292 14.3142 6.90892 14.5912C7.18592 14.8682 7.57492 15.0482 8.30892 15.1472C9.06392 15.2482 10.0649 15.2502 11.4999 15.2502H18.4999C18.6988 15.2502 18.8896 15.3292 19.0302 15.4699C19.1709 15.6105 19.2499 15.8013 19.2499 16.0002C19.2499 16.1991 19.1709 16.3899 19.0302 16.5305C18.8896 16.6712 18.6988 16.7502 18.4999 16.7502H11.4449C10.0779 16.7502 8.97492 16.7502 8.10792 16.6342C7.20792 16.5122 6.44992 16.2542 5.84792 15.6522C5.24592 15.0502 4.98792 14.2922 4.86692 13.3922C4.74992 12.5252 4.74992 11.4222 4.74992 10.0552V7.38322C4.74992 6.67022 4.74992 6.19822 4.70792 5.83722C4.66792 5.49522 4.60092 5.33122 4.51392 5.21122C4.42792 5.09122 4.29292 4.97422 3.98092 4.82922C3.65092 4.67622 3.20392 4.52522 2.52792 4.29922L2.26292 4.21222C2.16936 4.18105 2.08287 4.13173 2.0084 4.06709C1.93392 4.00245 1.87292 3.92376 1.8289 3.83552C1.78487 3.74728 1.75868 3.65122 1.75182 3.55285C1.74496 3.45448 1.75756 3.35671 1.78892 3.26322Z"
        fill="black"
      />
      <path
        opacity="0.5"
        d="M6.24219 6.5C6.24619 6.76 6.24785 7.04033 6.24719 7.341V10C6.24719 11.435 6.24919 12.437 6.35019 13.192C6.36552 13.302 6.38219 13.4047 6.40019 13.5H16.5202C17.4792 13.5 17.9582 13.5 18.3342 13.252C18.7102 13.004 18.8992 12.564 19.2762 11.682L19.7062 10.682C20.5152 8.792 20.9192 7.848 20.4752 7.174C20.0312 6.5 19.0032 6.5 16.9472 6.5H6.24219Z"
        fill="black"
      />
      <path
        d="M7.75 9.5C7.75 9.30109 7.82902 9.11032 7.96967 8.96967C8.11032 8.82902 8.30109 8.75 8.5 8.75H11.5C11.6989 8.75 11.8897 8.82902 12.0303 8.96967C12.171 9.11032 12.25 9.30109 12.25 9.5C12.25 9.69891 12.171 9.88968 12.0303 10.0303C11.8897 10.171 11.6989 10.25 11.5 10.25H8.5C8.30109 10.25 8.11032 10.171 7.96967 10.0303C7.82902 9.88968 7.75 9.69891 7.75 9.5ZM8 18.5C8.39782 18.5 8.77936 18.658 9.06066 18.9393C9.34196 19.2206 9.5 19.6022 9.5 20C9.5 20.3978 9.34196 20.7794 9.06066 21.0607C8.77936 21.342 8.39782 21.5 8 21.5C7.60218 21.5 7.22064 21.342 6.93934 21.0607C6.65804 20.7794 6.5 20.3978 6.5 20C6.5 19.6022 6.65804 19.2206 6.93934 18.9393C7.22064 18.658 7.60218 18.5 8 18.5ZM18.5 20C18.5 19.6022 18.342 19.2206 18.0607 18.9393C17.7794 18.658 17.3978 18.5 17 18.5C16.6022 18.5 16.2206 18.658 15.9393 18.9393C15.658 19.2206 15.5 19.6022 15.5 20C15.5 20.3978 15.658 20.7794 15.9393 21.0607C16.2206 21.342 16.6022 21.5 17 21.5C17.3978 21.5 17.7794 21.342 18.0607 21.0607C18.342 20.7794 18.5 20.3978 18.5 20Z"
        fill="black"
      />
    </svg>
    <svg
      v-if="name == 'persons2-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.49995 5C8.49995 5.66304 8.23656 6.29893 7.76772 6.76777C7.29888 7.23661 6.66299 7.5 5.99995 7.5C5.33691 7.5 4.70102 7.23661 4.23218 6.76777C3.76334 6.29893 3.49995 5.66304 3.49995 5C3.49995 4.33696 3.76334 3.70107 4.23218 3.23223C4.70102 2.76339 5.33691 2.5 5.99995 2.5C6.66299 2.5 7.29888 2.76339 7.76772 3.23223C8.23656 3.70107 8.49995 4.33696 8.49995 5ZM10.9 12.506C11.0099 13.048 10.552 13.5 9.99995 13.5H1.99995C1.44695 13.5 0.98995 13.048 1.09795 12.506C1.328 11.3758 1.94159 10.3597 2.83482 9.63C3.72805 8.90027 4.84603 8.50165 5.99945 8.50165C7.15287 8.50165 8.27085 8.90027 9.16408 9.63C10.0573 10.3597 10.6709 11.3758 10.901 12.506M14.002 12.5H12.412C12.4033 12.4027 12.39 12.306 12.372 12.21C12.1805 11.2666 11.7819 10.3776 11.205 9.607C11.94 9.4042 12.7246 9.48889 13.3995 9.84386C14.0743 10.1988 14.5886 10.7974 14.838 11.518C15.018 12.04 14.555 12.5 14.002 12.5ZM12 8.5C12.5304 8.5 13.0391 8.28929 13.4142 7.91421C13.7892 7.53914 14 7.03043 14 6.5C14 5.96957 13.7892 5.46086 13.4142 5.08579C13.0391 4.71071 12.5304 4.5 12 4.5C11.4695 4.5 10.9608 4.71071 10.5857 5.08579C10.2107 5.46086 9.99995 5.96957 9.99995 6.5C9.99995 7.03043 10.2107 7.53914 10.5857 7.91421C10.9608 8.28929 11.4695 8.5 12 8.5Z"
        fill="#00664D"
      />
    </svg>
    <svg
      v-if="name == 'submit-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6811 0.698053C15.5768 0.611509 15.4501 0.556371 15.3157 0.539062C15.1813 0.521752 15.0448 0.542984 14.922 0.600284L0.1875 7.51636V8.85462L6.3763 11.3301L10.346 17.4375H11.6845L15.9138 1.4273C15.9481 1.29618 15.9445 1.15802 15.9033 1.02891C15.8621 0.899801 15.785 0.785058 15.6811 0.698053ZM10.8581 16.161L7.44596 10.9114L12.6967 5.16047L11.8659 4.40194L6.57409 10.1977L1.47141 8.15663L14.6003 1.99402L10.8581 16.161Z"
        fill="#0066FF"
      />
    </svg>
    <svg
      v-if="name == 'attachment-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4608_8909)">
        <path
          d="M11.7048 5.74899L10.5629 4.60824L4.85353 10.3165C4.62868 10.5414 4.45033 10.8084 4.32866 11.1023C4.207 11.3961 4.14441 11.7111 4.14446 12.0291C4.14451 12.3472 4.20721 12.6621 4.32897 12.9559C4.45073 13.2497 4.62916 13.5167 4.85409 13.7416C5.07902 13.9664 5.34604 14.1448 5.6399 14.2664C5.93375 14.3881 6.2487 14.4507 6.56674 14.4506C6.88479 14.4506 7.19971 14.3879 7.49353 14.2661C7.78734 14.1444 8.0543 13.9659 8.27916 13.741L15.1304 6.89086C15.8874 6.13375 16.3126 5.10695 16.3125 4.03634C16.3124 2.96573 15.887 1.93901 15.1298 1.18205C14.3727 0.425092 13.3459 -0.00010547 12.2753 1.96238e-08C11.2047 0.000105509 10.178 0.425505 9.42103 1.18262L2.22778 8.37474L2.21203 8.38936C0.0126562 10.5887 0.0126562 14.1527 2.21203 16.351C4.41141 18.5492 7.97541 18.5492 10.1748 16.351L10.1894 16.3352L10.1905 16.3364L15.1012 11.4269L13.9593 10.2861L9.04866 15.1945L9.03403 15.2091C8.28044 15.9612 7.25923 16.3836 6.19453 16.3836C5.12983 16.3836 4.10863 15.9612 3.35503 15.2091C2.98122 14.8349 2.685 14.3905 2.4834 13.9015C2.28179 13.4125 2.17876 12.8885 2.18022 12.3596C2.18168 11.8307 2.28761 11.3072 2.49192 10.8194C2.69623 10.3315 2.9949 9.88875 3.37078 9.51661L3.36966 9.51549L10.564 2.32337C11.5079 1.37837 13.0447 1.37837 13.9897 2.32337C14.9347 3.26837 14.9335 4.80399 13.9897 5.74787L7.13841 12.598C6.98508 12.739 6.78319 12.8154 6.57491 12.8111C6.36663 12.8068 6.16807 12.7222 6.02069 12.5749C5.8733 12.4277 5.78851 12.2292 5.78401 12.0209C5.77951 11.8127 5.85565 11.6107 5.99653 11.4572L11.7059 5.74787L11.7048 5.74899Z"
          :fill="fill || 'black'"
        />
      </g>
      <defs>
        <clipPath id="clip0_4608_8909">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-if="name == 'document2-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.76575 2.29725C9.05246 2.4276 9.31336 2.60848 9.536 2.83125L14.012 7.30875C14.237 7.53375 14.417 7.794 14.5452 8.07825M8.76575 2.29725C8.42465 2.14241 8.05435 2.06236 7.67975 2.0625H5.84375C5.14756 2.0625 4.47988 2.33906 3.98759 2.83134C3.49531 3.32363 3.21875 3.99131 3.21875 4.6875V13.3125C3.21875 14.0087 3.49531 14.6764 3.98759 15.1687C4.47988 15.6609 5.14756 15.9375 5.84375 15.9375H12.1558C12.8519 15.9375 13.5196 15.6609 14.0119 15.1687C14.5042 14.6764 14.7808 14.0087 14.7808 13.3125V9.165C14.7808 8.78625 14.699 8.4165 14.5452 8.07825M8.76575 2.29725V6.5775C8.76575 6.97533 8.92379 7.35686 9.20509 7.63816C9.48639 7.91946 9.86793 8.0775 10.2657 8.0775L14.5452 8.07825"
        :stroke="stroke || '#000'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'image-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1797 2.625H5.80469C4.81013 2.625 3.8563 3.02009 3.15304 3.72335C2.44978 4.42661 2.05469 5.38044 2.05469 6.375V11.625C2.05469 12.1175 2.15168 12.6051 2.34014 13.0601C2.52859 13.515 2.80482 13.9284 3.15304 14.2767C3.8563 14.9799 4.81013 15.375 5.80469 15.375H12.1797C12.6721 15.375 13.1598 15.278 13.6148 15.0895C14.0697 14.9011 14.4831 14.6249 14.8313 14.2767C15.1796 13.9284 15.4558 13.515 15.6442 13.0601C15.8327 12.6051 15.9297 12.1175 15.9297 11.625V6.375C15.9297 5.88254 15.8327 5.39491 15.6442 4.93994C15.4558 4.48497 15.1796 4.07157 14.8313 3.72335C14.4831 3.37513 14.0697 3.09891 13.6148 2.91045C13.1598 2.722 12.6721 2.625 12.1797 2.625Z"
        :stroke="stroke || '#030303'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.24219 12.7502L4.30469 10.3502C4.57457 10.0822 4.92877 9.91559 5.30735 9.87869C5.68592 9.84178 6.06562 9.93682 6.38219 10.1477C6.69875 10.3586 7.07845 10.4536 7.45703 10.4167C7.8356 10.3798 8.18981 10.2132 8.45969 9.9452L10.2072 8.1977C10.7093 7.69387 11.3741 7.38485 12.083 7.32578C12.7918 7.26671 13.4986 7.46143 14.0772 7.8752L15.9447 9.3227M5.99219 7.6277C6.15568 7.6277 6.31758 7.59549 6.46863 7.53293C6.61968 7.47036 6.75693 7.37865 6.87254 7.26304C6.98814 7.14743 7.07985 7.01019 7.14242 6.85914C7.20498 6.70809 7.23719 6.54619 7.23719 6.3827C7.23719 6.2192 7.20498 6.0573 7.14242 5.90625C7.07985 5.7552 6.98814 5.61796 6.87254 5.50235C6.75693 5.38674 6.61968 5.29503 6.46863 5.23247C6.31758 5.1699 6.15568 5.1377 5.99219 5.1377C5.66199 5.1377 5.34532 5.26886 5.11184 5.50235C4.87836 5.73583 4.74719 6.0525 4.74719 6.3827C4.74719 6.71289 4.87836 7.02956 5.11184 7.26304C5.34532 7.49653 5.66199 7.6277 5.99219 7.6277Z"
        stroke="#030303"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'filter-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.64282 7.8795C3.77757 6.4845 2.44707 4.95 1.72032 4.0875C1.49532 3.8205 1.42182 3.62475 1.37757 3.2805C1.22607 2.1015 1.15032 1.512 1.49607 1.131C1.84182 0.75 2.45307 0.75 3.67557 0.75H12.3246C13.5471 0.75 14.1583 0.75 14.5041 1.13025C14.8498 1.51125 14.7741 2.10075 14.6226 3.27975C14.5776 3.624 14.5041 3.81975 14.2798 4.08675C13.5523 4.95075 12.2196 6.48825 10.3498 7.8855C10.2634 7.95278 10.1919 8.03735 10.14 8.13382C10.0881 8.23029 10.0568 8.33653 10.0483 8.44575C9.86307 10.494 9.69207 11.616 9.58557 12.183C9.41382 13.0995 8.11557 13.6508 7.41957 14.142C7.00557 14.4345 6.50307 14.0865 6.44982 13.6335C6.25067 11.9074 6.08214 10.1779 5.94432 8.44575C5.93661 8.33549 5.90579 8.22809 5.85384 8.13053C5.80189 8.03297 5.73 7.94744 5.64282 7.8795Z"
        :stroke="stroke || 'black'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'exclamation-mark-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
        fill="#FCFCFC"
        stroke="#484848"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 12V9M9 6H9.0075"
        stroke="#484848"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'shopping-cart'"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33203 11.0391C8.16627 11.0391 8.0073 11.1049 7.89009 11.2221C7.77288 11.3393 7.70703 11.4983 7.70703 11.6641C7.70703 11.8298 7.77288 11.9888 7.89009 12.106C8.0073 12.2232 8.16627 12.2891 8.33203 12.2891H11.6654C11.8311 12.2891 11.9901 12.2232 12.1073 12.106C12.2245 11.9888 12.2904 11.8298 12.2904 11.6641C12.2904 11.4983 12.2245 11.3393 12.1073 11.2221C11.9901 11.1049 11.8311 11.0391 11.6654 11.0391H8.33203Z"
        :fill="fill || '#030303'"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.2196 1.94098C12.3678 1.86688 12.5393 1.85467 12.6965 1.90701C12.8537 1.95936 12.9837 2.07199 13.0579 2.22014L14.5687 5.24181C14.9248 5.25903 15.2498 5.28848 15.5437 5.33014C16.4237 5.45598 17.1521 5.72764 17.6696 6.36764C18.1871 7.00764 18.3004 7.77681 18.2396 8.66348C18.1812 9.52264 17.9479 10.6068 17.6579 11.961L17.2821 13.7168C17.0862 14.631 16.9271 15.3718 16.7271 15.9501C16.5187 16.5543 16.2437 17.0501 15.7754 17.4293C15.3071 17.8085 14.7637 17.9726 14.1304 18.0501C13.5221 18.1243 12.7637 18.1243 11.8304 18.1243H8.16707C7.23207 18.1243 6.47457 18.1243 5.86624 18.0501C5.2329 17.9726 4.68957 17.8085 4.22124 17.4293C3.7529 17.0501 3.47791 16.5543 3.26957 15.951C3.06957 15.3718 2.91124 14.631 2.71457 13.7176L2.33874 11.9618C2.04874 10.6068 1.81624 9.52264 1.75707 8.66348C1.69624 7.77681 1.80957 7.00848 2.32707 6.36764C2.84374 5.72764 3.57207 5.45598 4.45207 5.33014C4.74652 5.28903 5.07152 5.25959 5.42707 5.24181L6.9404 2.22014C7.01522 2.07317 7.14509 1.96172 7.30171 1.91008C7.45834 1.85844 7.62902 1.87081 7.77658 1.94447C7.92413 2.01814 8.03658 2.14714 8.08944 2.30336C8.14229 2.45958 8.13125 2.63036 8.05874 2.77848L6.84207 5.20931C7.1454 5.20764 7.46457 5.20709 7.79957 5.20764H12.1979C12.5329 5.20764 12.8521 5.2082 13.1554 5.20931L11.9396 2.77848C11.8655 2.63028 11.8533 2.45872 11.9056 2.30152C11.958 2.14432 12.0706 2.01433 12.2187 1.94014M4.7754 6.54764L4.43957 7.21931C4.40215 7.29282 4.37966 7.37301 4.37338 7.45525C4.3671 7.5375 4.37717 7.62018 4.40299 7.69851C4.42882 7.77685 4.4699 7.8493 4.52386 7.91169C4.57782 7.97407 4.64359 8.02516 4.71739 8.06201C4.79119 8.09885 4.87155 8.12072 4.95385 8.12636C5.03614 8.132 5.11873 8.12129 5.19687 8.09486C5.275 8.06842 5.34713 8.02678 5.4091 7.97234C5.47106 7.9179 5.52164 7.85172 5.55791 7.77764L6.21374 6.46598C6.68874 6.45764 7.2304 6.45681 7.85041 6.45681H12.1471C12.7671 6.45681 13.3087 6.45681 13.7837 6.46514L14.4396 7.77764C14.5144 7.92462 14.6443 8.03607 14.8009 8.0877C14.9575 8.13934 15.1282 8.12698 15.2757 8.05331C15.4233 7.97965 15.5358 7.85065 15.5886 7.69443C15.6415 7.53821 15.6304 7.36743 15.5579 7.21931L15.2221 6.54764L15.3671 6.56681C16.1037 6.67264 16.4646 6.86514 16.6979 7.15264C16.9271 7.43597 17.0396 7.82181 16.9946 8.54014H3.00291C2.95791 7.82181 3.07041 7.43597 3.29957 7.15264C3.5329 6.86514 3.89374 6.67264 4.6304 6.56681L4.7754 6.54764ZM3.57207 11.7493C3.4288 11.0985 3.29518 10.4457 3.17124 9.79098H16.8262C16.7018 10.4457 16.5679 11.0985 16.4246 11.7493L16.0679 13.416C15.8612 14.3785 15.7179 15.0443 15.5454 15.5426C15.3787 16.026 15.2087 16.281 14.9896 16.4576C14.7712 16.6343 14.4854 16.7476 13.9796 16.8093C13.4554 16.8735 12.7737 16.8743 11.7896 16.8743H8.20707C7.22374 16.8743 6.54207 16.8735 6.01791 16.8093C5.51124 16.7476 5.22624 16.6343 5.00791 16.4576C4.78874 16.281 4.6179 16.0251 4.45207 15.5426C4.27957 15.0443 4.1354 14.3785 3.92957 13.416L3.57207 11.7493Z"
        :fill="fill || '#030303'"
      />
    </svg>
    <svg
      v-if="name == 'chat-comment'"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7066 6.25646V11.7623C17.7068 12.1962 17.6215 12.6259 17.4556 13.0268C17.2897 13.4277 17.0464 13.792 16.7396 14.0989C16.4328 14.4057 16.0686 14.6491 15.6677 14.8151C15.2668 14.9812 14.8371 15.0666 14.4032 15.0665H12.2007L10.3841 16.8831C10.3345 16.9356 10.2748 16.9774 10.2085 17.006C10.1422 17.0346 10.0708 17.0493 9.99865 17.0493C9.92647 17.0493 9.85506 17.0346 9.78878 17.006C9.72251 16.9774 9.66277 16.9356 9.61323 16.8831L7.79656 15.0665H5.5924C5.15853 15.0665 4.72891 14.981 4.32807 14.8149C3.92724 14.6489 3.56305 14.4055 3.25629 14.0986C2.94954 13.7918 2.70623 13.4276 2.54027 13.0267C2.37432 12.6258 2.28895 12.1962 2.28906 11.7623V6.25646C2.28906 5.38036 2.63709 4.54014 3.25659 3.92065C3.87608 3.30115 4.7163 2.95313 5.5924 2.95312H14.4024C15.2785 2.95313 16.1187 3.30115 16.7382 3.92065C17.3577 4.54014 17.7066 5.38036 17.7066 6.25646Z"
        :stroke="stroke || '#030303'"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99833 9.4524C10.0706 9.4524 10.1422 9.43816 10.209 9.4105C10.2757 9.38284 10.3364 9.34229 10.3875 9.29118C10.4386 9.24007 10.4792 9.17939 10.5069 9.11261C10.5345 9.04583 10.5487 8.97426 10.5487 8.90198C10.5487 8.8297 10.5345 8.75812 10.5069 8.69134C10.4792 8.62456 10.4386 8.56389 10.3875 8.51278C10.3364 8.46166 10.2757 8.42112 10.209 8.39346C10.1422 8.3658 10.0706 8.35156 9.99833 8.35156C9.85235 8.35156 9.71235 8.40955 9.60913 8.51278C9.50591 8.616 9.44792 8.756 9.44792 8.90198C9.44792 9.04796 9.50591 9.18796 9.60913 9.29118C9.71235 9.39441 9.85235 9.4524 9.99833 9.4524ZM13.8525 9.4524C13.9248 9.4524 13.9964 9.43816 14.0631 9.4105C14.1299 9.38284 14.1906 9.34229 14.2417 9.29118C14.2928 9.24007 14.3334 9.17939 14.361 9.11261C14.3887 9.04583 14.4029 8.97426 14.4029 8.90198C14.4029 8.8297 14.3887 8.75812 14.361 8.69134C14.3334 8.62456 14.2928 8.56389 14.2417 8.51278C14.1906 8.46166 14.1299 8.42112 14.0631 8.39346C13.9964 8.3658 13.9248 8.35156 13.8525 8.35156C13.7065 8.35156 13.5665 8.40955 13.4633 8.51278C13.3601 8.616 13.3021 8.756 13.3021 8.90198C13.3021 9.04796 13.3601 9.18796 13.4633 9.29118C13.5665 9.39441 13.7065 9.4524 13.8525 9.4524ZM6.14417 9.4524C6.21645 9.4524 6.28802 9.43816 6.3548 9.4105C6.42158 9.38284 6.48226 9.34229 6.53337 9.29118C6.58448 9.24007 6.62502 9.17939 6.65269 9.11261C6.68035 9.04583 6.69458 8.97426 6.69458 8.90198C6.69458 8.8297 6.68035 8.75812 6.65269 8.69134C6.62502 8.62456 6.58448 8.56389 6.53337 8.51278C6.48226 8.46166 6.42158 8.42112 6.3548 8.39346C6.28802 8.3658 6.21645 8.35156 6.14417 8.35156C5.99819 8.35156 5.85819 8.40955 5.75496 8.51278C5.65174 8.616 5.59375 8.756 5.59375 8.90198C5.59375 9.04796 5.65174 9.18796 5.75496 9.29118C5.85819 9.39441 5.99819 9.4524 6.14417 9.4524Z"
        :stroke="stroke || '#030303'"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'check-average'"
      :width="width"
      :height="height"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 16.6406H7.5C5.025 16.6406 3.7875 16.6406 3.01875 15.8719C2.25 15.1031 2.25 13.8656 2.25 11.3906V3.14062M4.5 9.89062H4.50675M6.74925 9.89062H6.75525M8.99775 9.89062H9.00375M11.2462 9.89062H11.253M13.4948 9.89062H13.5015M15.7432 9.89062H15.75"
        :stroke="stroke || '#2E2E2E'"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.5 6.14062C5.00475 5.29913 5.69025 4.64062 6.74475 4.64062C11.202 4.64062 8.69625 13.6406 13.4865 13.6406C14.5485 13.6406 15.2295 12.9776 15.75 12.1406"
        :stroke="stroke || '#2E2E2E'"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'arrow-up'"
      :width="width"
      :height="height"
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4.39062V0.953125H8.5625"
        :stroke="stroke || '#0E905E'"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 0.953125L8.5625 4.39062C7.95544 4.99769 7.65225 5.30088 7.28031 5.33456C7.21844 5.34006 7.15656 5.34006 7.09469 5.33456C6.72275 5.30019 6.41956 4.99769 5.8125 4.39062C5.20544 3.78356 4.90225 3.48037 4.53031 3.44669C4.46856 3.44111 4.40644 3.44111 4.34469 3.44669C3.97275 3.48106 3.66956 3.78356 3.0625 4.39062L1 6.45312"
        :stroke="stroke || '#0E905E'"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'arrow-down'"
      :width="width"
      :height="height"
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3.01562V6.45312H8.5625"
        stroke="#FE5E60"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 6.45312L8.5625 3.01562C7.95544 2.40856 7.65225 2.10537 7.28031 2.07169C7.21844 2.06619 7.15656 2.06619 7.09469 2.07169C6.72275 2.10606 6.41956 2.40856 5.8125 3.01562C5.20544 3.62269 4.90225 3.92588 4.53031 3.95956C4.46856 3.96514 4.40644 3.96514 4.34469 3.95956C3.97275 3.92519 3.66956 3.62269 3.0625 3.01562L1 0.953125"
        stroke="#FE5E60"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'calculator'"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      :style="{ cursor: cursorPointer ? 'pointer' : '', 'pointer-events': 'auto' }"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.24238 16.7579C4.40175 17.9173 6.26772 17.9173 9.99967 17.9173C13.7316 17.9173 15.5976 17.9173 16.757 16.7579C17.9163 15.5986 17.9163 13.7326 17.9163 10.0007C17.9163 6.2687 17.9163 4.40272 16.757 3.24335C15.5976 2.08398 13.7316 2.08398 9.99967 2.08398C6.26772 2.08398 4.40175 2.08398 3.24238 3.24335C2.08301 4.40272 2.08301 6.2687 2.08301 10.0007C2.08301 13.7326 2.08301 15.5986 3.24238 16.7579Z"
        fill="white"
        stroke="#808080"
      />
      <path
        d="M14.75 7.2298H11.5833M14.75 11.9798H11.5833M14.75 14.3548H11.5833M8.41667 7.22981H6.83333M6.83333 7.22981L5.25 7.22981M6.83333 7.22981L6.83333 5.64647M6.83333 7.22981L6.83333 8.81313M8.02083 11.9798L6.83334 13.1673M6.83334 13.1673L5.64584 14.3548M6.83334 13.1673L5.64583 11.9798M6.83334 13.1673L8.02082 14.3548"
        stroke="#808080"
        stroke-linecap="round"
      />
    </svg>
    <svg
      v-if="name == 'two-grid-layout'"
      :width="width"
      :height="height"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.17746 3H14.8222C15.0496 3 15.2676 3.09031 15.4283 3.25105C15.5891 3.4118 15.6794 3.62981 15.6794 3.85714V7.28571C15.6794 7.51304 15.5891 7.73106 15.4283 7.89181C15.2676 8.05255 15.0496 8.14286 14.8222 8.14286H3.17746C2.95013 8.14286 2.73211 8.05255 2.57136 7.89181C2.41062 7.73106 2.32031 7.51304 2.32031 7.28571V3.85714C2.32031 3.62981 2.41062 3.4118 2.57136 3.25105C2.73211 3.09031 2.95013 3 3.17746 3ZM3.17746 9.85714H14.8222C15.0496 9.85714 15.2676 9.94745 15.4283 10.1082C15.5891 10.2689 15.6794 10.487 15.6794 10.7143V14.1429C15.6794 14.3702 15.5891 14.5882 15.4283 14.7489C15.2676 14.9097 15.0496 15 14.8222 15H3.17746C2.95013 15 2.73211 14.9097 2.57136 14.7489C2.41062 14.5882 2.32031 14.3702 2.32031 14.1429V10.7143C2.32031 10.487 2.41062 10.2689 2.57136 10.1082C2.73211 9.94745 2.95013 9.85714 3.17746 9.85714Z"
        :stroke="stroke"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'four-grid-layout'"
      :width="width"
      :height="height"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7143 3H14.1429C14.3702 3 14.5882 3.09031 14.7489 3.25105C14.9097 3.4118 15 3.62981 15 3.85714V7.28571C15 7.51304 14.9097 7.73106 14.7489 7.89181C14.5882 8.05255 14.3702 8.14286 14.1429 8.14286H10.7143C10.487 8.14286 10.2689 8.05255 10.1082 7.89181C9.94745 7.73106 9.85714 7.51304 9.85714 7.28571V3.85714C9.85714 3.62981 9.94745 3.4118 10.1082 3.25105C10.2689 3.09031 10.487 3 10.7143 3ZM3.85714 3H7.28571C7.51304 3 7.73106 3.09031 7.89181 3.25105C8.05255 3.4118 8.14286 3.62981 8.14286 3.85714V7.28571C8.14286 7.51304 8.05255 7.73106 7.89181 7.89181C7.73106 8.05255 7.51304 8.14286 7.28571 8.14286H3.85714C3.62981 8.14286 3.4118 8.05255 3.25105 7.89181C3.09031 7.73106 3 7.51304 3 7.28571V3.85714C3 3.62981 3.09031 3.4118 3.25105 3.25105C3.4118 3.09031 3.62981 3 3.85714 3ZM10.7143 9.85714H14.1429C14.3702 9.85714 14.5882 9.94745 14.7489 10.1082C14.9097 10.2689 15 10.487 15 10.7143V14.1429C15 14.3702 14.9097 14.5882 14.7489 14.7489C14.5882 14.9097 14.3702 15 14.1429 15H10.7143C10.487 15 10.2689 14.9097 10.1082 14.7489C9.94745 14.5882 9.85714 14.3702 9.85714 14.1429V10.7143C9.85714 10.487 9.94745 10.2689 10.1082 10.1082C10.2689 9.94745 10.487 9.85714 10.7143 9.85714ZM3.85714 9.85714H7.28571C7.51304 9.85714 7.73106 9.94745 7.89181 10.1082C8.05255 10.2689 8.14286 10.487 8.14286 10.7143V14.1429C8.14286 14.3702 8.05255 14.5882 7.89181 14.7489C7.73106 14.9097 7.51304 15 7.28571 15H3.85714C3.62981 15 3.4118 14.9097 3.25105 14.7489C3.09031 14.5882 3 14.3702 3 14.1429V10.7143C3 10.487 3.09031 10.2689 3.25105 10.1082C3.4118 9.94745 3.62981 9.85714 3.85714 9.85714Z"
        :stroke="stroke"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'no-image'"
      :width="width"
      :height="height"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.25 7.75C16.0784 7.75 16.75 7.07843 16.75 6.25C16.75 5.42157 16.0784 4.75 15.25 4.75C14.4216 4.75 13.75 5.42157 13.75 6.25C13.75 7.07843 14.4216 7.75 15.25 7.75Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.75 12.8847C1.41733 12.7947 2.08933 12.7507 2.766 12.7527C5.622 12.6967 8.408 13.5227 10.626 15.0837C12.686 16.5317 14.131 18.5237 14.75 20.7497M12.25 16.2497C13.25 15.2497 13.927 15.0267 14.75 14.7497"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.75 18.963C17.351 20.25 15.113 20.25 10.75 20.25C6.272 20.25 4.032 20.25 2.641 18.859C1.25 17.468 1.25 15.229 1.25 10.75C1.25 6.387 1.25 4.149 2.537 2.75M18.75 14.75C19.293 14.75 19.798 15.044 20.147 15.314C20.25 14.119 20.25 12.633 20.25 10.75C20.25 6.272 20.25 4.032 18.859 2.641C17.468 1.25 15.229 1.25 10.75 1.25C8.34 1.25 6.58 1.25 5.25 1.467M0.75 0.75L20.75 20.75"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'has-image'"
      :width="width"
      :height="height"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 10.25C0.75 5.772 0.75 3.532 2.141 2.141C3.532 0.75 5.771 0.75 10.25 0.75C14.728 0.75 16.968 0.75 18.359 2.141C19.75 3.532 19.75 5.771 19.75 10.25C19.75 14.728 19.75 16.968 18.359 18.359C16.968 19.75 14.729 19.75 10.25 19.75C5.772 19.75 3.532 19.75 2.141 18.359C0.75 16.968 0.75 14.729 0.75 10.25Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.75 7.25C15.5784 7.25 16.25 6.57843 16.25 5.75C16.25 4.92157 15.5784 4.25 14.75 4.25C13.9216 4.25 13.25 4.92157 13.25 5.75C13.25 6.57843 13.9216 7.25 14.75 7.25Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.25 20.2497C13.63 18.0247 12.185 16.0317 10.127 14.5837C7.907 13.0227 5.122 12.1967 2.266 12.2527C1.926 12.252 1.58733 12.2627 1.25 12.2847"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.25 16.2501C12.951 14.9231 14.785 14.2431 16.636 14.2501C17.7085 14.2543 18.7686 14.4797 19.75 14.9121"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'slice-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.001 12C21.553 12 22.006 11.551 21.951 11.002C21.7205 8.70621 20.7031 6.56074 19.0713 4.92936C17.4396 3.29798 15.2939 2.28108 12.998 2.05104C12.448 1.99604 12 2.44904 12 3.00104V11.001C12 11.2663 12.1054 11.5206 12.2929 11.7081C12.4804 11.8957 12.7348 12.001 13 12.001L21.001 12Z"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.2104 15.89C20.5742 17.3944 19.5792 18.7202 18.3123 19.7513C17.0454 20.7823 15.5452 21.4874 13.9428 21.8047C12.3405 22.1221 10.6848 22.0421 9.12055 21.5718C7.55627 21.1014 6.13103 20.255 4.96942 19.1066C3.80782 17.9582 2.94522 16.5427 2.45704 14.9839C1.96886 13.4251 1.86996 11.7704 2.169 10.1646C2.46804 8.55874 3.1559 7.05058 4.17245 5.77199C5.189 4.49339 6.50329 3.48327 8.0004 2.82996"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="name == 'posCard-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 5H4C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5Z"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 10H22"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="name == 'wallet-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 7V4C19 3.73478 18.8946 3.48043 18.7071 3.29289C18.5196 3.10536 18.2652 3 18 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5C3 5.53043 3.21071 6.03914 3.58579 6.41421C3.96086 6.78929 4.46957 7 5 7H20C20.2652 7 20.5196 7.10536 20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V12M21 12H18C17.4696 12 16.9609 12.2107 16.5858 12.5858C16.2107 12.9609 16 13.4696 16 14C16 14.5304 16.2107 15.0391 16.5858 15.4142C16.9609 15.7893 17.4696 16 18 16H21C21.2652 16 21.5196 15.8946 21.7071 15.7071C21.8946 15.5196 22 15.2652 22 15V13C22 12.7348 21.8946 12.4804 21.7071 12.2929C21.5196 12.1054 21.2652 12 21 12Z"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H20C20.2652 21 20.5196 20.8946 20.7071 20.7071C20.8946 20.5196 21 20.2652 21 20V16"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="name == 'plus-customer'"
      :width="width"
      :height="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 8V14"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22 11H16"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="name == 'tick-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.8026 9.99999C22.2593 12.2413 21.9338 14.5714 20.8804 16.6018C19.827 18.6322 18.1095 20.24 16.0141 21.1573C13.9187 22.0746 11.5722 22.2458 9.36586 21.6424C7.15954 21.0389 5.22676 19.6974 3.88984 17.8414C2.55293 15.9854 1.89269 13.7272 2.01923 11.4434C2.14577 9.15952 3.05144 6.98808 4.58522 5.29116C6.11899 3.59424 8.18815 2.47442 10.4476 2.11844C12.7071 1.76247 15.0203 2.19185 17.0016 3.33499"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 11L12 14L22 4"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="name == 'billan'"
      :width="width"
      :height="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 16H12.01"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 16H16.01"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V8.5C21.0001 8.4103 20.9761 8.32223 20.9304 8.24502C20.8848 8.1678 20.8192 8.10429 20.7405 8.06114C20.6619 8.01798 20.5731 7.99678 20.4835 7.99975C20.3938 8.00271 20.3066 8.02974 20.231 8.078L15.769 10.922C15.6934 10.9703 15.6062 10.9973 15.5165 11.0003C15.4269 11.0032 15.3381 10.982 15.2595 10.9389C15.1808 10.8957 15.1152 10.8322 15.0696 10.755C15.0239 10.6778 14.9999 10.5897 15 10.5V8.5C15.0001 8.4103 14.9761 8.32223 14.9304 8.24502C14.8848 8.1678 14.8192 8.10429 14.7405 8.06114C14.6619 8.01798 14.5731 7.99678 14.4835 7.99975C14.3938 8.00271 14.3066 8.02974 14.231 8.078L9.77 10.922C9.69437 10.9705 9.60707 10.9978 9.51727 11.0009C9.42747 11.004 9.33849 10.9828 9.2597 10.9396C9.1809 10.8965 9.1152 10.8328 9.0695 10.7555C9.0238 10.6781 8.99979 10.5899 9 10.5V5C9 4.46957 8.78929 3.96086 8.41421 3.58579C8.03914 3.21071 7.53043 3 7 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19Z"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 16H8.01"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="name == 'circle-alert-outline'"
      :width="width"
      :height="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 8V12"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 16H12.01"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="name == 'medal'"
      :width="width"
      :height="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4787 12.89L16.9937 21.416C17.0107 21.5164 16.9966 21.6196 16.9533 21.7118C16.9101 21.8039 16.8397 21.8807 16.7516 21.9318C16.6636 21.9829 16.562 22.0059 16.4605 21.9977C16.359 21.9895 16.2624 21.9506 16.1837 21.886L12.6037 19.199C12.4309 19.0699 12.2209 19.0001 12.0052 19.0001C11.7895 19.0001 11.5795 19.0699 11.4067 19.199L7.8207 21.885C7.74202 21.9494 7.64557 21.9884 7.5442 21.9966C7.44283 22.0048 7.34138 21.9818 7.25337 21.9309C7.16536 21.8799 7.09498 21.8033 7.05162 21.7113C7.00827 21.6194 6.99399 21.5163 7.0107 21.416L8.5247 12.89"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 14C15.3137 14 18 11.3137 18 8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8C6 11.3137 8.68629 14 12 14Z"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="name == 'bag-shop'"
      :width="width"
      :height="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.10156 6.03406H20.8956"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.4 5.467C3.14036 5.81319 3 6.23426 3 6.667V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6.667C21 6.23426 20.8596 5.81319 20.6 5.467L18.6 2.8C18.4137 2.55161 18.1721 2.35 17.8944 2.21115C17.6167 2.07229 17.3105 2 17 2H7C6.68951 2 6.38328 2.07229 6.10557 2.21115C5.82786 2.35 5.58629 2.55161 5.4 2.8L3.4 5.467Z"
        :stroke="stroke || '#fff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="name === 'currency-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.9987 0.833374H3.7487C2.97515 0.833374 2.23328 1.14066 1.6863 1.68765C1.13932 2.23463 0.832031 2.97649 0.832031 3.75004C0.832031 4.52359 1.13932 5.26545 1.6863 5.81244C2.23328 6.35942 2.97515 6.66671 3.7487 6.66671H7.91536C8.68891 6.66671 9.43078 6.974 9.97776 7.52098C10.5247 8.06796 10.832 8.80983 10.832 9.58337C10.832 10.3569 10.5247 11.0988 9.97776 11.6458C9.43078 12.1928 8.68891 12.5 7.91536 12.5H0.832031"
        :stroke="stroke || '#7BF1A8'"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name === 'cube-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16667 18.1083C9.42003 18.2546 9.70744 18.3316 10 18.3316C10.2926 18.3316 10.58 18.2546 10.8333 18.1083L16.6667 14.775C16.9198 14.6288 17.13 14.4187 17.2763 14.1657C17.4225 13.9126 17.4997 13.6256 17.5 13.3333V6.66663C17.4997 6.37435 17.4225 6.0873 17.2763 5.83426C17.13 5.58122 16.9198 5.37109 16.6667 5.22496L10.8333 1.89163C10.58 1.74535 10.2926 1.66833 10 1.66833C9.70744 1.66833 9.42003 1.74535 9.16667 1.89163L3.33333 5.22496C3.08022 5.37109 2.86998 5.58122 2.72372 5.83426C2.57745 6.0873 2.5003 6.37435 2.5 6.66663V13.3333C2.5003 13.6256 2.57745 13.9126 2.72372 14.1657C2.86998 14.4187 3.08022 14.6288 3.33333 14.775L9.16667 18.1083Z"
        :stroke="stroke || '#FFB86A'"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M10 18.3333V10"
        :stroke="stroke || '#FFB86A'"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M2.74219 5.83337L10.0005 10L17.2589 5.83337"
        :stroke="stroke || '#FFB86A'"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M6.25 3.55835L13.75 7.85002"
        :stroke="stroke || '#FFB86A'"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name === 'users-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3346 17.5V15.8333C13.3346 14.9493 12.9834 14.1014 12.3583 13.4763C11.7332 12.8512 10.8854 12.5 10.0013 12.5H5.0013C4.11725 12.5 3.2694 12.8512 2.64428 13.4763C2.01916 14.1014 1.66797 14.9493 1.66797 15.8333V17.5"
        :stroke="stroke || '#FDA5D5'"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M13.332 2.60669C14.0468 2.792 14.6799 3.20941 15.1318 3.79341C15.5837 4.37741 15.8289 5.09493 15.8289 5.83336C15.8289 6.57178 15.5837 7.28931 15.1318 7.8733C14.6799 8.4573 14.0468 8.87471 13.332 9.06002"
        :stroke="stroke || '#FDA5D5'"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M18.332 17.5001V15.8334C18.3315 15.0948 18.0857 14.3774 17.6332 13.7937C17.1807 13.2099 16.5471 12.793 15.832 12.6084"
        :stroke="stroke || '#FDA5D5'"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M7.5013 9.16667C9.34225 9.16667 10.8346 7.67428 10.8346 5.83333C10.8346 3.99238 9.34225 2.5 7.5013 2.5C5.66035 2.5 4.16797 3.99238 4.16797 5.83333C4.16797 7.67428 5.66035 9.16667 7.5013 9.16667Z"
        :stroke="stroke || '#FDA5D5'"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'not-send-icon'"
      :width="width"
      :height="height"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 0.75H10L13 3.75V14.25H4V0.75Z"
        :stroke="stroke || '#030303'"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M10 0.75V3.75H13"
        :stroke="stroke || '#030303'"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M6.5 6.5V11"
        :stroke="stroke || '#030303'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M9.5 6.5V11"
        :stroke="stroke || '#030303'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
    <svg
      v-if="name == 'message-icon'"
      :style="{ cursor: cursorPointer ? 'pointer' : '' }"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 3.25h7.25c1.1 0 2 .9 2 2v5.25c0 1.1-.9 2-2 2H13.5l-2.5 2.25V12.5H7.5c-1.1 0-2-.9-2-2V5.25c0-1.1.9-2 2-2z"
        :stroke="stroke || fill || 'black'"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.5 6.75H4.25c-1.1 0-2 .9-2 2v5.25c0 1.1.9 2 2 2H5.5l2.5 2.25V16H11.5"
        :stroke="stroke || fill || 'black'"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="name == 'file-upload-icon' || name == 'file-clock-icon'"
      :style="{ cursor: cursorPointer ? 'pointer' : '' }"
      :width="width"
      :height="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.75 2.75H5.75c-.83 0-1.5.67-1.5 1.5v11.5c0 .83.67 1.5 1.5 1.5h8.5c.83 0 1.5-.67 1.5-1.5V7.25L11.75 2.75z"
        :stroke="stroke || fill || 'black'"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.75 2.75V7.25H16.25"
        :stroke="stroke || fill || 'black'"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 14V9.25M8 11l2-2 2 2"
        :stroke="stroke || fill || 'black'"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    width: Number,
    height: Number,
    cursorPointer: Boolean,
    compositeType: String,
    fill: String,
    stroke: String,
  },
};
</script>

<style scoped></style>
